var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 18,
  fill: "none",
  viewBox: "0 0 9 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.885 10.192a2 2 0 0 1 0-2.384l4.51-6.075C6.542.186 9 .998 9 2.925v12.15c0 1.927-2.457 2.739-3.606 1.192z"
})));
export { SvgLeftWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDkgMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjg4NDg4OSAxMC4xOTIxQzAuMzU5NDM2IDkuNDg0MjEgMC4zNTk0MzYgOC41MTU3OSAwLjg4NDg4OSA3LjgwNzkyTDUuMzk0MDkgMS43MzMzNUM2LjU0MjY4IDAuMTg2MDI2IDkgMC45OTgzOTQgOSAyLjkyNTQzTDkgMTUuMDc0NkM5IDE3LjAwMTYgNi41NDI2OCAxNy44MTQgNS4zOTQwOSAxNi4yNjY3TDAuODg0ODg5IDEwLjE5MjFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";